module.exports = __webpack_public_path__ + "img/klaus-a3-1.6307f9ad.jpg";